module.exports = __webpack_public_path__ + "img/iconAlerttwo (1).cf4dfda5.svg";